module.exports = __webpack_public_path__ + "img/kontakt_1920.9f1193be.webp";